module.exports = __webpack_public_path__ + "img/particleLottery.8cde877d.gif";